import React from "react";
import Skeleton from "react-loading-skeleton";

const MembershipSkeleton: React.FC = () => {
    return (
        <div className="card card-style py-2 position-relative">
            <div className="content">
                <div className="d-flex justify-content-center w-100">
                    <div className="w-25">
                        <Skeleton className="text-center" height={50} />
                    </div>
                </div>
                <div className="divider mt-4"></div>
                <div className="d-flex justify-content-between align-items-center">
                    <div className="d-flex flex-column">
                        <Skeleton height={20} width={100} />
                        <Skeleton height={20} width={125} />
                    </div>
                    <h1 className="font-40 text-center">
                        <Skeleton height={65} width={70} />
                    </h1>
                    <div className="d-flex flex-column justify-content-end align-items-end">
                        <Skeleton height={20} width={100} />
                        <Skeleton height={20} width={125} />
                    </div>
                </div>
                <div className="divider mt-4"></div>
                <div className="table-responsive px-3 ">
                    <table className="table align-middle table-row-dashed o">
                        <thead>
                            <tr className="border-bottom">
                                <th><Skeleton height={20} className="w-100" /></th>
                                <th className="text-end"><Skeleton height={20} className="w-75" /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                Array.from({ length: 4 }).map((_, i) => {
                                    return (
                                        <tr key={i}>
                                            <td>
                                                <Skeleton height={20} className="w-100" />
                                            </td>
                                            <td className="text-end">
                                                <Skeleton height={20} className="w-25" />
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <Skeleton height={40} className="btn btn-sm w-100 rounded-4" />
            </div>
            <div className=" position-absolute" style={{ left: "6px" }}>
                <Skeleton height={30} width={100} className="rounded-sm" />
            </div>
        </div>
    )
}

export default MembershipSkeleton;